export const toggleSelectArrayById = <T extends { id: string | undefined; isSelected: boolean }>(lines: T[], id: string): T[] => {
	const index = lines.findIndex(t => t.id === id);
	if (index === -1) {
		return lines;
	} else {
		return [...lines.slice(0, index), { ...lines[index], isSelected: !lines[index].isSelected }, ...lines.slice(index + 1)];
	}
};
